<div style="margin: auto;text-align: center; ">
    <div>
      <h2  class="mat-display-2 hello">Hello World</h2>
      <h1 class="mat-display-4" >I am Anthony Angatia</h1>
      <h2 class="mat-display-2">A Software Developer</h2>
      <h2 class="mat-display-1">Java | Kotlin | Angular | Php | Javascript | Node</h2>
    </div>
    <app-footer></app-footer>
</div>
